var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('div',{staticClass:"container page"},[_c('content-db',{attrs:{"contentKey":_vm.theKey,"isCache":true},on:{"title-onset":function($event){_vm.contentTitle=$event}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }